

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';

export interface InvestigationsParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface Investigation {
    id?: any;
    tenantId: any;
    branchId: any;
    regid:any;
    visitid:any;
    testresult:string;
    notes:string;
    serviceId : any;
    woPriority?:number;
    physicianId?:any;
    labSentStatus?:any;
	labworkorderdetid?:any;
    labworkordermstid?:any;
	radSentStatus?:any;
    approvalStatus?:any;
    //Log
    createdDate?:Date;
    updatedDate?:Date;
    createdBy?:number;
    updatedBy?:number;
    createdIP?:string;
    updatedIP?:string;
    parameters?: InvestigationsParameter[];
    links?: any;

    //Discount

    isDiscount?:boolean;
    discountType?:number;
    discountAmount?:number;
    discountPercentage?:number;
    amount?:number;
    netAmount?:number;
    performingNurse?:string;
    performingDoctor?:string;

    isOutsideLab?:boolean;

    patientAmount?:number;
    companyAmount?:number;
    vatPatient?:number;
    vatCompany?:number;
    isCovered?:boolean;
    priorAuth?:boolean;
    itemSequence?:number;
    nphiesCalc?:boolean;
    billUtilizationDetail?:any;
    visitLimitExceeded?:boolean;
    entrySequence?:number;
    billType?:string;
    payerId?:string;
    afterDisc?:number;
    nphiesCategoryId?:string;
    reviewStatus?:any;
    otPlanSurgeryStartDateTime?: any;
    otPlanSurgeryEndDateTime?: any;
}


export abstract class InvestigationData {
    //abstract fireRequest(data: Department, method: string): Observable<any>;
    abstract list(url: string): Observable<Investigation[]>;
    abstract create(url: string, data: Investigation): Observable<Investigation[]>;
    abstract update(url: string, data: Investigation): Observable<Investigation>;
    abstract delete(url: string): Observable<any>;
}
